import * as React from "react";
import { forwardRef } from "react";
const SvgMinusSign = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", baseProfile: "tiny", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 8 17", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 7h8v2H0z" }));
const ForwardRef = forwardRef(SvgMinusSign);
export default ForwardRef;
